<template>
    <div class="result-buttons-pair d-flex justify-space-between">
        <v-tooltip location="bottom"
                   text="Не выполнено">
            <template v-slot:activator="{ props }">
                <v-btn density="comfortable"
                       variant="text"
                       :color="falseButtonColor"
                       v-bind="props"
                       @click="value = false"
                       icon="mdi-circle-off-outline" />
            </template>
        </v-tooltip>
        <v-tooltip location="bottom"
                   text="Выполнено">
            <template v-slot:activator="{ props }">
                <v-btn density="comfortable"
                       variant="text"
                       :color="trueButtonColor"
                       v-bind="props"
                       @click="value = true"
                       icon="mdi-check-circle-outline" />
            </template>
        </v-tooltip>
    </div>
</template>

<script>
    export default {
        props: ["modelValue"],

        emits: ["update:modelValue"],

        data() {
            return {
                value: this.modelValue
            };
        },

        computed: {
            falseButtonColor() {
                if (this.value === false) {
                    return "error";
                }
                if (this.value === true) {
                    return "grey-lighten-1";
                }

                return "grey-darken-1";
            },
            trueButtonColor() {
                if (this.value === true) {
                    return "success";
                }
                if (this.value === false) {
                    return "grey-lighten-1";
                }

                return "grey-darken-1";
            }
        },

        watch: {
            value(newValue) {
                this.$emit("update:modelValue", newValue);
            }
        }
    };
</script>

<style lang="scss">
    .result-buttons-pair {
    }
</style>